import React, { Component } from "react";
import HeroArt from "./HeroArt";

class Hero extends Component {
  render() {
    const { stats, showUpcoming, showMetrics, t, language } = this.props;

    return (
      <section className="hero">
        <div className="hero-copy">
          <p className="eyebrow">{t("hero.eyebrow")}</p>
          <h1>{t("hero.title")}</h1>
          <p className="hero-sub">{t("hero.subtitle")}</p>
          <div className="hero-actions">
            <a className="btn primary" href="#apps">
              {t("hero.ctaPrimary")}
            </a>
            {showUpcoming && (
              <a className="btn ghost" href="#upcoming">
                {t("hero.ctaSecondary")}
              </a>
            )}
          </div>
          {showMetrics && stats.length > 0 && (
            <div className="hero-metrics">
              {stats.map((stat) => (
                <div className="metric" key={stat.value}>
                  <span className="metric-value">{stat.value}</span>
                  <span className="metric-label">
                    {(stat.label && stat.label[language]) || stat.label}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
        <HeroArt />
      </section>
    );
  }
}

export default Hero;
